﻿import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import Select from "react-select";
import { useToasts } from "react-toast-notifications";

import { hasPermission, toast } from "@/services/Utils";

import classes from "../../maintainers.module.scss";
import Fetching from "@/components/Fetching/Fetching";

import { base_quarter } from "../quarters.constants";
import api from "@/services/api.service";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const QuartersForm = ({ categories, species, varieties, confirmSave, permissions }) => {
	const { addToast } = useToasts();
	const location = useLocation();
	const { option, slug } = useParams();
	const navigate = useNavigate();

	const [isFetching, setIsFetching] = useState(true);
	const [data, setData] = useState({ ...base_quarter });

	const handleClose = () => {
		emptyFields();
		if (location.state) {
			navigate(location.state);
			return;
		}

		if (location.pathname.includes("configuracion")) {
			navigate("/configuracion/paso-3");
			return;
		}

		if (location.pathname.includes("mantenedores")) {
			navigate("/mantenedores/paso-3");
			return;
		}
	};

	const validSave = () => {
		if (!data.name) {
			toast(addToast, "Debe ingresar un nombre para guardar.", "error");
			return false;
		}

		if (!data.customer && location.pathname.includes("mantenedores")) {
			addToast("Debe seleccionar un cliente para guardar.", {
				appearance: "error",
			});

			return false;
		}

		return true;
	};

	const handleSave = () => {
		if (validSave()) {
			confirmSave({ form: data }, setIsFetching, afterSave);
		}
	};

	const emptyFields = () => {
		setData({ ...base_quarter });
	};

	const afterSave = () => {
		handleClose();
		addToast("Registro guardado correctamente.", {
			appearance: "success",
		});
	};

	useEffect(() => {
		setIsFetching(true);
		if (option && slug) {
			api.get("/admin/quarters/detail", { slug }).then((response) => {
				const { detail } = response;
				if (detail) {
					setData(detail);
				} else {
					addToast("Ocurrió un problema al cargar el registro seleccionado.", {
						appearance: "error",
					});
					handleClose();
				}
				setIsFetching(false);
			});
		} else {
			setIsFetching(false);
		}
		// eslint-disable-next-line
	}, [slug, option]);

	return (
		<Modal show={option ? true : false} onHide={handleClose} backdrop="static" keyboard={false} className={classes.main_form}>
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>Paso 3</h4>
			</Modal.Header>
			<Modal.Body>
				{isFetching ? (
					<Fetching topMargin={"1em"} />
				) : (
					<Row className={classes.row_form}>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Nombre</Form.Label>
								<Form.Control
									value={data.name ? data.name : ""}
									onChange={(e) =>
										setData({
											...data,
											name: e.currentTarget.value,
										})
									}
									type="text"
								/>
							</Form.Group>
						</Col>

						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Categoría</Form.Label>
								<Select
									value={categories && categories.filter((c) => Number(c.value) === Number(data.category_id))}
									placeholder={<div>Seleccione</div>}
									options={categories ? categories : []}
									onChange={(value) =>
										setData({
											...data,
											category_id: value ? value.value : "",
											specie_id: "",
											variety_id: "",
										})
									}
									components={{
										NoOptionsMessage,
									}}
									isClearable
								/>
							</Form.Group>
						</Col>

						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Paso 1</Form.Label>
								<Select
									value={species && species.filter((c) => Number(c.value) === Number(data.specie_id))}
									placeholder={<div>Seleccione</div>}
									options={species ? species.filter((s) => Number(s.category_id) === Number(data.category_id)) : []}
									onChange={(value) =>
										setData({
											...data,
											specie_id: value ? value.value : "",
											variety_id: "",
										})
									}
									components={{
										NoOptionsMessage,
									}}
									isClearable
								/>
							</Form.Group>
						</Col>

						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Paso 2</Form.Label>
								<Select
									value={varieties && varieties.filter((c) => Number(c.value) === Number(data.variety_id))}
									placeholder={<div>Seleccione</div>}
									options={varieties ? varieties.filter((v) => Number(v.specie_id) === Number(data.specie_id)) : []}
									onChange={(value) =>
										setData({
											...data,
											variety_id: value ? value.value : "",
										})
									}
									components={{
										NoOptionsMessage,
									}}
									isClearable
								/>
							</Form.Group>
						</Col>
					</Row>
				)}
			</Modal.Body>
			<Modal.Footer>
				{(slug ? hasPermission("edit", permissions) : hasPermission("create", permissions)) && !isFetching && (
					<Button variant="success" onClick={handleSave}>
						GUARDAR
					</Button>
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default QuartersForm;
